import { mapGetters } from 'vuex'
import Misc from 'src/utils/helper/misc'

export default {
  ...mapGetters('submissions', {
    submission: ['submission'],
    submissionList: ['list'],
    getSubmissionBinary: ['binary'],
    submittingSubmission: ['processing'],
    submissionLimitError: ['isSubmissionLimitError'],
    credibility: ['submissionCredibility'],
    isFontInvalid: ['fontValidationError'],
    getInitialSubmissionPackage: ['getInitialSubmissionPackage'],
    getCustomPackageModal: ['getCustomPackageModal'],
    getValidCustomPackageLength: ['getValidCustomPackageLength'],
    getAllowedCustomPackageLength: ['getAllowedCustomPackageLength'],
    getCountFontFiles: ['getCountFontFiles']
  }),
  ...mapGetters('foundrySupport', {
    foundryDetails: ['foundryDetails']
  }),

  stepsErrors() {
    const steppers = ['upload', 'prices', 'descriptions', 'graphics']
    let steppersAllErrros = []
    steppers.forEach(step => {
      if (this.step(step).errors.length) {
        if (this.fetchErrorsExceptRequired(step).length) {
          steppersAllErrros.push(this.fetchErrorsExceptRequired(step))
        }
      }
    })
    return steppersAllErrros
  },
  requiredErrorsOnly() {
    return this.fetchErrorsOnlyRequired()
  },
  accordionItemClassForUploadSection() {
    return [
      this.$style.item,
      { [this.$style.complete]: this.step('upload').complete },
      { [this.$style.error]: this.step('upload').anyErrors() }
    ]
  },
  accordionItemClassForPriceSection() {
    return [
      this.$style.item,
      { [this.$style.complete]: this.step('prices').complete },
      { [this.$style.error]: this.step('prices').anyErrors() }
    ]
  },
  accordionItemClassForDescriptionSection() {
    return [
      this.$style.item,
      { [this.$style.complete]: this.step('descriptions').complete },
      { [this.$style.error]: this.step('descriptions').anyErrors() }
    ]
  },
  accordionItemClassForGraphicsSection() {
    return [
      this.$style.item,
      { [this.$style.complete]: this.step('graphics').complete },
      { [this.$style.error]: this.step('graphics').anyErrors() }
    ]
  },
  submissionMessageHistory: {
    get() {
      return this.submission?.messageHistory || []
    }
  },
  submissionDesigners: {
    get() {
      return this.submission.userMetaData?.designers || []
    },
    set(designers) {
      if (this.submission.userMetaData?.designers) {
        this.submission.userMetaData.designers = designers
      }
    }
  },
  submissionFamily: {
    get() {
      return this.submission.userMetaData?.family || {}
    },
    set(family) {
      if (this.submission.userMetaData?.family) {
        this.submission.userMetaData.family = family
      }
    }
  },
  submissionCustomerMessage: {
    get() {
      return this.submission.userMetaData?.customerMessage || ''
    },
    set(customerMessage) {
      this.submission.userMetaData.customerMessage = customerMessage
    }
  },
  submissionFamilyName: {
    get() {
      return this.submission.userMetaData?.family?.name
    },
    set(name) {
      if (this.submission.userMetaData?.family?.name) {
        this.submission.userMetaData.family.name = name
      }
    }
  },
  submissionCategory: {
    get() {
      return this.submission.userMetaData?.category || {}
    },
    set(category) {
      if (this.submission?.userMetaData) {
        this.submission.userMetaData.category = category;
      }
    }
  },
  submissionCategoryName: {
    get() {
      return this.submission.userMetaData?.category?.name
    },
    set(name) {
      if (this.submission.userMetaData?.category?.name) {
        this.submission.userMetaData.category.name = name
      }
    }
  },
  submissionFoundryName: {
    get() {
      return this.submission.foundry?.name
    },
    set(name) {
      if (this.submission.foundry?.name) {
        this.submission.foundry.name = name
      }
    }
  },
  submissionVendorName: {
    get() {
      return this.submission.vendor?.name
    },
    set(name) {
      if (this.submission.vendor?.name) {
        this.submission.vendor.name = name
      }
    }
  },
  submissionFoundryId: {
    get() {
      return this.submission.foundry?.foundryId
    }
  },
  submissionBinaries: {
    get() {
      return this.submission.userMetaData?.binaries || []
    },
    set(binaries) {
      if (this.submission.userMetaData?.binaries) {
        this.submission.userMetaData.binaries = binaries
      }
    }
  },
  submissionFamilyDescriptions: {
    get() {
      return this.submission.userMetaData?.familyDescriptions || []
    },
    set(descriptions) {
      if (this.submission.userMetaData?.familyDescriptions) {
        const familyDescription = [
          {
            language: descriptions[0].language,
            description: Misc.HTTPinString(descriptions[0].description)
          }
        ]
        this.submission.userMetaData.familyDescriptions = familyDescription
      }
    }
  },
  submissionTags: {
    get() {
      const raw = this.submission?.userMetaData?.tags
      const tags = Array.isArray(raw) ? raw : [];
      const uniqueTags = tags.reduce((acc, current) => {
        const x = acc.find(item => item.name.toLowerCase() === current.name.toLowerCase());
        if (!x) {
          acc.push(current);
        }
        return acc;
      }, []);
      return uniqueTags;
    },
    set(tags) {
      if (this.submission.userMetaData) {
        this.submission.userMetaData.tags = Array.isArray(tags) ? tags : []
      }
    }
  },
  submissionFamilies: {
    get() {
      return this.submission.userMetaData?.familyGroup || []
    },
    set(families) {
      if (this.submission.userMetaData?.familyGroup) {
        this.submission.userMetaData.familyGroup = families
      }
    }
  },
  submissionImageSortorders: {
    get() {
      return this.submission.userMetaData?.imageSortorders || []
    },
    set(orders) {
      if (this.submission.userMetaData?.imageSortorders) {
        this.submission.userMetaData.imageSortorders = orders
      }
    }
  },
  submissionDefaultLayoutFont: {
    get() {
      return this.submission.userMetaData?.defaultLayoutFont || {}
    },
    set(font) {
      if (this.submission.userMetaData?.defaultLayoutFont) {
        this.submission.userMetaData.defaultLayoutFont = font
      }
    }
  },
  submissionFoundry: {
    get() {
      return this.submission.foundry || {}
    },
    set(foundry) {
      if (this.submission?.foundry) {
        this.submission.foundry = foundry
      }
    }
  },
  submissionVendor: {
    get() {
      return this.submission.vendor || {}
    },
    set(vendor) {
      if ((this.submission || {}).vendor) {
        this.submission.vendor = vendor
      }
    }
  },
  submissionPackages: {
    get() {
      return (this.submission.userMetaData || {}).packages || []
    },
    set(packages) {
      if ((this.submission.userMetaData || {}).packages) {
        this.submission.userMetaData.packages = packages
      }
    }
  },
  submissionPimBinaries: {
    get() {
      return (this.submission.userMetaData || {}).pimBinaries || []
    },
  },
  submissionFamilyExternalSku: {
    get() {
      if (this.submissionPackages.length > 0) {
        return this.submissionPackages[0].externalSku || ''
      }
    },
    set(externalsku) {
      this.submission.userMetaData.packages[0].externalSku = externalsku
    }
  },
  submissionURLFoundryName: {
    get() {
      let foundryURL = String((this.submission.foundry || {}).name)
      foundryURL = Misc.trimString(foundryURL).replace(/ \s*/g, '-')
      return foundryURL
    },
    set(name) {
      if ((this.submission.foundry || {}).name) {
        this.submission.foundry.name = name
      }
    }
  },
  submissionFamilyURLName: {
    get() {
      return Misc.normalizeDiacriticsOnString(((this.submission.userMetaData || {}).family || {}).uniqueName)
    },
    set(name) {
      if (this.submission?.userMetaData?.family?.uniqueName) {
        this.submission.userMetaData.family.uniqueName = name
      }
    }
  },
  submissionPimFamilyId: {
    get() {
      return this.submission?.userMetaData?.family?.pimFamilyId
    },
    set(pimFamilyId) {
      if (this.submission?.userMetaData?.family?.pimFamilyId) {
        this.submission.userMetaData.family.pimFamilyId = pimFamilyId
      }
    }
  },
  foundryRootDir: {
    get() {
      return this.foundryDetails.directory
    }
  },
  isFamilyUnique: {
    get() {
      return this.submission.isUniqueName
    },
    set(name) {
      if (this.submission.isUniqueName || {}) {
        this.submission.isUniqueName = name
      }
    }
  },
  externalDataSource: {
    get() {
      return this.submission.externalDataSource === 'PIM'
    }
  },
  isMonotypeFoundry: {
    get() {
      const fId = '2'
      return window.localStorage.getItem('sessionFoundryId') === fId
    }
  },
  isEditable: {
    get() {
      if (this.submission.hasOwnProperty('isEditable')) {
        return this.submission.isEditable
      }
      return true
    }
  }
}
